import { faArrowAltCircleLeft } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { Helmet } from 'react-helmet-async'
import splash from '../../media/classroomSplash.jpg'
import QuoteIcon from '../../media/icon-science.svg?react'
import oftmcssLogo from '../../media/maricopa-footer-logo.svg'
import { Brand, Content, Templates } from 'ui'
import * as Forms from './Forms'
import { randomTestimonial } from './testimonials'
import { Link } from 'react-router-dom'

/**
 * Generic form to request an invitation to reset a password.
 */
export const ForgotPasswordView: React.FC = () => {
  const testimonial = randomTestimonial()
  return (
    <Templates.SplashImageView
      backgroundImageSrc={splash}
      footerImageSrc={oftmcssLogo}
      splashContent={
        <Templates.SplashQuote
          quote={testimonial.quote}
          author={testimonial.author}
          title={testimonial.title}
          icon={
            <QuoteIcon
              style={{
                width: 'auto',
                height: '60px',
                display: 'block',
              }}
              className="fill-current text-white"
            />
          }
        />
      }
    >
      <Helmet>
        <title>Forgot Your Password? - MCSS PRO Connect</title>
      </Helmet>
      <Content.Region>
        <Brand.EpcLogo />
        <Content.Heading>Reset Your Password</Content.Heading>
        <Forms.ForgotPassword />
        <Content.List>
          <Content.ListItem>
            <Content.ListIcon>
              <FontAwesomeIcon icon={faArrowAltCircleLeft} />
            </Content.ListIcon>
            <Link to="/login">Return to Login.</Link>
          </Content.ListItem>
        </Content.List>
      </Content.Region>
    </Templates.SplashImageView>
  )
}
